import { ApoQueryable } from '../modules/apo/models/apoRecord.model';
import { NoticeConditionModel } from '../modules/apo/models/NoticeConditionModel.model';
import { OwnerModel } from './ownerModel.model';
import { ParcelInfoModel } from './parcelInfoModel.model';

export class RefAddressModel  implements ApoQueryable {
    /// <remarks/>
    publicSourceSeqNBR: string;

    /// <remarks/>
    addressDescription: string;

    /// <remarks/>
    addressLine1: string;

    /// <remarks/>
    addressLine2: string;

    /// <remarks/>
    addressStatus: string;

    /// <remarks/>
    addressType: string;

    /// <remarks/>
    addressTypeFlag: string;

    /// <remarks/>
    auditDate: Date;

    /// <remarks/>
    auditID: string;

    /// <remarks/>
    auditStatus: string;

    /// <remarks/>
    city: string;

    /// <remarks/>
    country: string;

    /// <remarks/>
    countryCode: string;

    /// <remarks/>
    county: string;

    /// <remarks/>
    crossStreetNameEnd: string;

    /// <remarks/>
    crossStreetNameStart: string;

    /// <remarks/>
    distance: number;

    /// <remarks/>
    //duplicatedAPOKeys: Array<DuplicatedAPOKeyModel>;

    /// <remarks/>
    eventID: string;

    /// <remarks/>
    fullAddress: string;

    /// <remarks/>
    hightestCondition: NoticeConditionModel;

    /// <remarks/>
    houseFractionEnd: string;

    /// <remarks/>
    houseFractionStart: string;

    /// <remarks/>
    houseNumberEnd: number;

    /// <remarks/>
    houseNumberRangeEnd: number;

    /// <remarks/>
    houseNumberRangeStart: number;

    /// <remarks/>
    houseNumberStart: number;

    /// <remarks/>
    inspectionDistrict: string;

    /// <remarks/>
    inspectionDistrictPrefix: string;

    /// <remarks/>
    locationType: string;

    /// <remarks/>
    lot: string;

    /// <remarks/>
    mappingDailyAddressNbr: string;

    /// <remarks/>
    neighborhoodPrefix: string;

    /// <remarks/>
    neighborhood: string;

    /// <remarks/>
    noticeConditions: Array<NoticeConditionModel>;

    /// <remarks/>
    ownerModelLists: Array<OwnerModel>;

    /// <remarks/>
    parcelLists: Array<ParcelInfoModel>;

    /// <remarks/>
    parcelNumber: string;

    /// <remarks/>
    primaryFlag: string;

    /// <remarks/>
    refAddressId: number;

    /// <remarks/>
    refAddressTypes: Array<string>;

    /// <remarks/>
    resCountryCode: string;

    /// <remarks/>
    resState: string;

    /// <remarks/>
    resStreetDirection: string;

    /// <remarks/>
    resStreetSuffix: string;

    /// <remarks/>
    resStreetSuffixdirection: string;

    /// <remarks/>
    resUnitType: string;

    /// <remarks/>
    secondaryRoad: string;

    /// <remarks/>
    secondaryRoadNumber: number;

    /// <remarks/>
    sourceFlag: string;

    /// <remarks/>
    sourceNumber: number;

    /// <remarks/>
    state: string;

    /// <remarks/>
    streetDirection: string;

    /// <remarks/>
    streetName: string;

    /// <remarks/>
    streetNameStart: string;

    /// <remarks/>
    streetNameEnd: string;

    /// <remarks/>
    streetPrefix: '';

    /// <remarks/>
    streetSuffix: string;

    /// <remarks/>
    streetSuffixdirection: string;

    /// <remarks/>
    subdivision: string;

    /// <remarks/>
    //templates: Array<TemplateAttributeModel>;

    /// <remarks/>
    UID: string;

    /// <remarks/>
    unitEnd: string;

    /// <remarks/>
    unitRangeEnd: string;

    /// <remarks/>
    unitRangeStart: string;

    /// <remarks/>
    unitStart: string;

    /// <remarks/>
    unitType: string;

    /// <remarks/>
    XCoordinator: number;

    /// <remarks/>
    YCoordinator: number;

    /// <remarks/>
    zip: string;

    /// <remarks/>
    levelPrefix: string;

    /// <remarks/>
    levelNumberStart: string;

    /// <remarks/>
    levelNumberEnd: string;

    /// <remarks/>
    houseNumberAlphaStart: string;

    /// <remarks/>
    houseNumberAlphaEnd: string;

    /// <remarks/>
    houseNumberStartFrom: number;

    /// <remarks/>
    houseNumberStartTo: number;

    /// <remarks/>
    houseNumberEndFrom: number;

    /// <remarks/>
    houseNumberEndTo: number;
}
